import { useState } from 'react';
import Swal from 'sweetalert2';
import {FaSpinner} from 'react-icons/fa'; 
import styles from './AboutProgram.module.css';

const AboutProgram = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try { 
        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/enviar-correo`, {
            method: 'POST', 
            headers: { 
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        }); 
        const data = await response.json();
        if (response.ok) { 
            setFormData({
                name: '', 
                email: '', 
                message: ''
            }); 
            Swal.fire({
                icon: 'success',
                title: '¡Mensaje enviado!',
                text: 'Nos pondremos en contacto contigo pronto.',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#242b57', 
            customClass: { 
                popup: 'popupbonito', 
            },
            });
        } else { 
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: data.error || 'Error al enviar mensaje',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#242b57', 
                customClass: { 
                    popup: 'popupbonito', 
            },
                
            });
        }
    } catch (error) { 
        console.error('Error: ', error); 
        Swal.fire({
            icon: 'error',
            title: 'Error de conexión',
            text: 'Ya has enviado muchos correos.',
            confirmButtonText: 'Aceptar'
        });
    } finally { 
        setIsSubmitting(false);
    }
};

    return (
        <div className={styles.aboutProgramPage}>
            <main>
                <section className={styles.aboutProgram}>
                    <h1>Acerca del programa</h1>
                    <p>
                        Este programa tiene como objetivo principal apoyar a los jóvenes en su proceso de orientación vocacional, brindándoles herramientas interactivas y personalizadas para tomar decisiones informadas sobre su futuro académico y profesional.
                    </p>
                    <p>
                        A través de nuestra plataforma, los usuarios podrán explorar perfiles de carreras, conocer universidades, y acceder a recursos diseñados para fomentar la continuidad educativa y reducir la deserción escolar.
                    </p>
                    <p>
                        Este proyecto es impulsado por la Secretaría de Educación de Querétaro, con el respaldo del gobierno estatal y expertos en educación.
                    </p>
                    <p className={styles.callToAction}>
                        ¡Forma parte de esta iniciativa y descubre todo lo que podemos ofrecerte!
                    </p>
                </section>
            </main>

            <div className={styles.content}>
                <div className={styles.contactContainer}>
                    <div className={styles.contactForm}>
                        <h2>Envíanos tus comentarios</h2>
                        <form onSubmit={handleSubmit}>
                            <label htmlFor="name">Nombre:</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />

                            <label htmlFor="email">Correo Electrónico:</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />

                            <label htmlFor="message">Mensaje:</label>
                            <textarea
                                id="message"
                                name="message"
                                rows="4"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>

                            <button 
                                type="submit" 
                                disabled={isSubmitting}
                                style={{
                                    opacity: isSubmitting ? 0.6 : 1,
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {isSubmitting ? (
                                    <>
                                        <FaSpinner className={styles.spinner}/>{' '}
                                        Enviando...
                                    </>
                                ) : (
                                    'Enviar'
                                )}
                            </button>
                        </form>
                    </div>
                    <div className={styles.contactMap}>
                        <h2>Nuestra ubicación</h2>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3734.886852775541!2d-100.39169578988825!3d20.592677802535473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d344fa828fd2b1%3A0x88bd6c0390803f0c!2sSecretar%C3%ADa%20de%20Educaci%C3%B3n!5e0!3m2!1sen!2smx!4v1716010729140!5m2!1sen!2smx" 
                            width="100%"
                            height="400"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            title="Mapa de la Secretaría de Educación"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutProgram;